export default class User {
    constructor(json) {

        /**
         * @type {number}
         */
        this.id = json.id;

        /**
         * @type {String}
         */
        this.firstName = json.firstName;

        /**
         * @type {String}
         */
        this.activity = json.activity;

      /**
         * @type {String}
         */
        this.lastName = json.lastName;

      /**
       * @type {String}
       */
      this.userAuthority = json.userAuthority;
    }
}
